var url = "//search.bulbamerica.com/equipment/getData.php";

function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

function setData(data){
    toAppend = '';
    if(data['brand'].length >= 1){
        toAppend += '<option value="">Brand</option>';
        $.each(data['brand'],function(i,o){
            if(getParameterByName('brand') == o.value){
                select = 'selected= "selected"';
            }else{
                select = '';
            }
            toAppend += '<option value ="' + o.id + '"' + select +'>'+o.value+'</option>';
        });
        $("#brand").empty().append(toAppend);
        $("#brandMedical").css("display", "table-cell");
        $("#brand").chosen();
        
    }
    
    toAppend = '';
    if(data['model'].length >= 1){
        toAppend += '<option value="">Model</option>';
        $.each(data['model'],function(i,o){
            if(getParameterByName('model') == o.value){
                select = 'selected= "selected"';
            }else{
                select = '';
            }
            toAppend += '<option value ="' + o.id + '"' + select +'>'+o.value+'</option>';
        });
        $("#model").empty().append(toAppend);
        $("#modelMedical").css("display", "table-cell");
        $("#model").chosen();
        
    }
    
    toAppend = '';
    if(data['ansi'].length >= 1){
        toAppend += '<option value="">ANSI</option>';
        $.each(data['ansi'],function(i,o){
            if(getParameterByName('ansi') == o.value){
                select = 'selected= "selected"';
            }else{
                select = '';
            }
            toAppend += '<option value ="' + o.id + '"' + select +'>'+o.value+'</option>';
        });
        $("#ansi").empty().append(toAppend);
      $("#ansiMedical").css("display", "table-cell");
        $("#ansi").chosen();
        
    }
    $("#resetBTNmedical").css("display", "table-cell");
}

function setTable(data){
    var toAppend = "";
    toAppend += '<div class="header-row">'
                    + '<div class="cell"> Brand </div>'
                    + '<div class="cell"> Model </div>'
                    + '<div class="cell"> ANSI </div>'
                    + '</div>';
    $.each(data,function(i,o){
        toAppend += '<div class="row">'
                    + '<div class="cell">' + o.brand + '</div>'
                    + '<div class="cell"><a class="link" onclick="setModelValue(' + o.model_id + ')">' + o.model + '</a></div>'
                    + '<div class="cell"><a class="link" onclick="setAnsiValue(' + o.ansi_id + ')">' + o.ansi + '</a></div>'
                    + '</div>';
    });
    $("#data-table").empty().append(toAppend);
}

function setModelValue(id){
    $("#model").val(id);
    valueChanged("model", 'm');
}

function setAnsiValue(id){
    $("#ansi").val(id);
    valueChanged("ansi", 'a');
}

function setProducts(data){
    var toAppend = "";
    toAppend += "<div class='collection-wrap clearfix'>" +
                        "<div class='collection-main'>" +
                           "<ul class='block-grid collection-th columns5'>";
    $.each(data,function(i,o){
        toAppend += 
                "<li>" +
                    "<a class='prod-th show-quick' href='" + o.link + "' title='" + o.name + "' style='height: 353px;'>" +
                        "<span class='thumbnail'>" +
                            "<img src='" + o.image_link + "' alt='" + o.name + "'>" +
                            "<span class='quick-view' data-prdid='#prod-" + o.id + "' style='display: none;'>QUICK VIEW</span>" +
                        "</span>" +
                        "<span class='product-title'>" + o.name + "</span>" +
                        "<span><b>SKU:</b> " + o.sku + "</span>";
                price = o.price.split('.', 2);
      			if(o.quantity > 0){
                    toAppend += "<span class='price'><em><span style='font-size:15px;vertical-align: top; position:relative; bottom: 0.1em;'>$</span>" 
                    + price[0] 
                    + "<span style='font-size:15px;vertical-align: top; position:relative; bottom: 0.1em;'>" 
                    + price[1] + "</span>"         
                    + "</em></span>";
                }else{
                    toAppend += "<span class='price sold-out'><em>OUT OF STOCK</em></span>"
                }
                //        "{{#on_sale}}<span class='sale round'><i>SALE</i></span>{{/on_sale}}" +
                toAppend += "</a>" +
                    "<div id='prod-" + o.id + "' class='white-popup mfp-hide clearfix'>" +
                        "<div class='product-images clearfix'>" +
                            "<span class='main-image'>" +
                                "<img src='" + o.image_link + "' alt='" + o.name + "'>" +
                //               "{{#on_sale}}<span class='sale round'><i>SALE</i></span>{{/on_sale}}" +
                            "</span>" +
                        "</div>" +
                        "<div class='product-details'>" +
                        "<h1>" + o.name + "</h1>" +
                        "<b>Item SKU:</b> " + o.sku +
                        "<div class='product-price-wrap'>" +
                            "<span class='price'><em><span style='font-size:15px;vertical-align: top; position:relative; bottom: 0.1em;'>$</span>" 
                    + price[0] 
                    + "<span style='font-size:15px;vertical-align: top; position:relative; bottom: 0.1em;'>" 
                    + price[1] + "</span>"         
                    + "</em></span>" +
                        "</div>";
                if(o.quantity > 0){
                    toAppend += "<form action='/cart/add' onSubmit='return checkProductQty(" + o.id + ", " + o.variant_id + ", \"" + o.name + "\"," +  o.quantity + ");' method='post' class='cartableProduct single-var'>" +
                                "<div class='product-variants'>" +
                                    "<fieldset>" +
                                        "<input type='hidden' name='id' value='" + o.variant_id + "'>" +
                                    "</fieldset>" +
                                    "<div class='var-msg'></div>" +
                                "</div>  " +
                                "<div class='quick-actions clearfix'>" +
                                    "<p class='qty-field'>" +
                                        "<label for='product-quantity-" + o.id + "'>Qty:</label>" +
                                        "<input type='number' id='product-quantity-" + o.id + "' name='quantity' value='1' min='1'>" +
                                    "</p>" +
                                    "<div id='inventory' style='float: left; font-weight: bold; font-size: 1em; text-align: center; padding-top: 15px;'>" + o.quantity + " in stock</div>" +
                                    "<input type='submit' class='add-to-cart' class='btn' name='add' value='Add to cart'>" +
                                 "</div>" +
                            "</form>";
                }else{
                    toAppend += "<p style='color: #F70023'><strong>Sorry, this product is temporarily out of stock.</strong></p>";
                }
                toAppend += "<div class='product-description rte'>" + o.description + "</div>" +
                                "<a href='" + o.link + "'><strong>» View full product details</strong></a>" +
                                "<br> <br>" +
                            "</div>" +
                    "</div>" +
                "</li>";
    });
    toAppend += "</ul></div></div>";
    $("#products").html(toAppend);
    $("#productHeader").html("Your Results:");
    bindQuickView();
}


function valueChanged(action, letter){
    var order = getParameterByName("order");
    var length = order.length;
    var first_letter = order.substring(0,1);
    var second_letter = order.substring(1,2);
    var lastChar = order.substring(order.length - 1);
    var reset_all = false;
    var reset =  false;
    if(first_letter == letter && length > 1){
        reset_all = true;
    }
    if(second_letter == letter && length > 2){
        reset = true;
    }
    
    if(order){
        var letter_index = order.search(letter);
        if(letter_index == -1){
            order = order.concat(letter);
        }
    }else{
        order = letter;
    }

    var queryParameters = {}, queryString = location.search.substring(1), re = /([^&=]+)=([^&]*)/g, m;

    while (m = re.exec(queryString)) {
        queryParameters[decodeURIComponent(m[1])] = decodeURIComponent(m[2]);
    }
    queryParameters['brand'] = "";
    queryParameters['model'] = "";
    queryParameters['ansi'] = "";
    queryParameters['order'] = "";
      
    if($("#brand").val())
        queryParameters['brand'] = $("#brand option:selected").text();
    if($("#model").val())
        queryParameters['model'] = $("#model option:selected").text();
    if($("#ansi").val())
        queryParameters['ansi'] = $("#ansi option:selected").text();
    
    if(reset_all){
        if(first_letter == 'b'){
            queryParameters['model'] = "";
            queryParameters['ansi'] = "";
            order = 'b';
        }
        if(first_letter == 'm'){
            queryParameters['brand'] = "";
            queryParameters['ansi'] = "";
            order = 'm';
        }
        if(first_letter == 'a'){
            queryParameters['model'] = "";
            queryParameters['brand'] = "";
            order = 'a';
        }
    }
    
    if(reset){
        if(lastChar == 'b'){
            queryParameters['brand'] = "";
        }
        if(lastChar == 'm'){
            queryParameters['model'] = "";
        }
        if(lastChar == 'a'){
            queryParameters['ansi'] = "";
        }
    }
    
    var lastChar = order.substring(order.length - 1);
    if(queryParameters['brand'] == "" && lastChar == 'b')
        order = order.substring(0, order.length - 1);
    if(queryParameters['model'] == "" && lastChar == 'm')
        order = order.substring(0, order.length - 1);
    if(queryParameters['ansi'] == "" && lastChar == 'a')
        order = order.substring(0, order.length - 1);
    
    queryParameters['order'] = order;
    
    location.search = $.param(queryParameters); // Causes page to reload
}

function pageReady(){
    
    var brand = getParameterByName("brand");
    var model = getParameterByName("model");
    var ansi = getParameterByName("ansi");
    var order = getParameterByName("order");

    $.ajax({
     type: "POST",
     url: url,
     async: false,
     data: {brand: brand,
            model: model,
            ansi: ansi,
            order: order},
     dataType: "json",
     success: function(data){
         setData(data);
         if(data['table'])
             setTable(data['table']);
         if(data['products'])
            if(data['products'].length)
                setProducts(data['products']);
            else{
                var toAppend = "<b>No Product available for the above selection.</b>";
                $("#message").html(toAppend);
            }
     },
     error: function(){
         alert("error");
     } 
 });
}